import { findElementAll, selectedElementAll } from "../utils/element-handlers.utils";

function textareaElementBehavior(textareaElement: HTMLElement) {
    window.addEventListener('resize', resizeTextarea);
    textareaElement.addEventListener('input', resizeTextarea);

    function resizeTextarea() {
        textareaElement.style.height = '30px';
        textareaElement.style.height = textareaElement.scrollHeight + 'px';
    }
}

function buttonResetElementBehavior(buttonElement: HTMLElement, formElement: HTMLFormElement) {
    buttonElement.addEventListener('click', event => {
        findElementAll<HTMLSelectElement>('select', formElement).forEach(selectElement => {
            if (selectElement.parentElement?.classList.contains('selectric-hide-select')) {
                selectElement.value = '';
                eval('jQuery(selectElement).selectric("refresh")');
            }
        });
    });
}

function FormComponent(formElement: HTMLFormElement) {
    findElementAll('textarea', formElement).forEach(textareaElementBehavior);
    findElementAll('button[type="reset"]', formElement).forEach(resetButtonElement => buttonResetElementBehavior(resetButtonElement, formElement));
}

export default function initFormComponent() {
    selectedElementAll('.n-form', FormComponent)
}